//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

    /*
     * Factories
     */
  curalate.factory('ItemLaunchOptions', [
    'UniversalImageActionsNetworkTypes',
    'UniversalImageActionsView',
    'UniversalItemId',
    function(
            UniversalImageActionsNetworkTypes,
            UniversalImageActionsView,
            UniversalItemId,
        ) {
      const ItemLaunchOptions = function(itemType, itemId, options) {
        this.launchView = UniversalImageActionsView.Home;
        this.launchWorkflow = null;
        this.itemType = itemType.toLowerCase();
        this.itemId = itemId;
        this.products = [];
        _(this).extend(options);
      };

      ItemLaunchOptions.prototype.getItemType = function() {
        return this.itemType;
      };

      ItemLaunchOptions.prototype.getItemId = function() {
        return this.itemId;
      };

      ItemLaunchOptions.prototype.getSourceNetwork = function() {
        const isNetworkType = _(UniversalImageActionsNetworkTypes).contains(this.itemType);
        return this.socialNetwork || (isNetworkType ? this.itemType : null);
      };

      ItemLaunchOptions.prototype.getUniversalItemId = function() {
        return this.getUniversalItemIdObj().toString();
      };

      ItemLaunchOptions.prototype.getUniversalItemIdObj = function() {
        if (!this.universalItemIdObj) {
          this.universalItemIdObj = new UniversalItemId(this.itemType, this.itemId);
        }

        return this.universalItemIdObj;
      };

      ItemLaunchOptions.prototype.getLaunchView = function() {
        return this.launchView;
      };

      ItemLaunchOptions.prototype.setLaunchView = function(launchView) {
        this.launchView = launchView;
      };

      ItemLaunchOptions.prototype.getLaunchWorkflow = function() {
        return this.launchWorkflow;
      };

      ItemLaunchOptions.prototype.setLaunchWorkflow = function(workflow) {
        this.launchWorkflow = workflow;
      };

      ItemLaunchOptions.prototype.setLaunchReel = function(reel) {
        this.selectedReel = reel;
      };

      ItemLaunchOptions.prototype.getLaunchReel = function() {
        return this.selectedReel;
      };

      ItemLaunchOptions.prototype.setShowroomLaunchContext = function(showroomContext) {
        this.showroomContext = showroomContext;
      };

      ItemLaunchOptions.prototype.getShowroomLaunchContext = function() {
        return this.showroomContext;
      };

      ItemLaunchOptions.prototype.setLaunchProducts = function(products) {
        if (!_.isArray(products)) {
          products = [products];
        }
        this.products = angular.copy(products);
      };

      ItemLaunchOptions.prototype.getLaunchProducts = function() {
        return this.products;
      };

      return ItemLaunchOptions;
    },
  ]);
})();
